module.exports = __webpack_public_path__ + "img/2018-09-4.8d4d057e.jpeg";